'use es6';

import { TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Task = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated('CRM:ILSFilters:ActivityFilters'),
  objectTypeId: TASK_TYPE_ID,
  referenceObjectType: 'TASK_PROPERTIES'
});
export default Task;